
export class PolygonDrawer {
	constructor(canvas, drawingHistory) {
		this.canvas = canvas;
		this.drawingHistory = drawingHistory;

		this.resetPolygon();
	}

	handleMouseDown(e) {
		if (this.editorModeOn) return;

		if (e.target && this.pointArray.length && e.target === this.pointArray[0]) {
			this._finishDrawing();
		} else {
			const pointer = this.canvas.getPointer(e.e);
			this._addPoint(pointer);
		}
	}

	handleMouseMove(e) {
		if (this.editorModeOn) return;

		if (this.activeLine && this.activeLine.class == "line") {
			const pointer = this.canvas.getPointer(e.e);
			this.activeLine.set({ x2: pointer.x, y2: pointer.y });

			const shapePoints = this.activeShape.get("points");
			shapePoints[this.pointArray.length] = { x: pointer.x, y: pointer.y };
			this.activeShape.set({ points: shapePoints });
		}
		this.canvas.renderAll();
	}

	_getPoint(pointer, selectable = false) {
		const circle = new fabric.Circle({
			radius: 20,
			fill: '#ffffff',
			stroke: '#333333',
			strokeWidth: 0.5,
			left: pointer.x,
			top: pointer.y,
			selectable: selectable,
			hasBorders: false,
			hasControls: false,
			originX: 'center',
			originY: 'center',
			objectCaching: false
		});
		return circle;
	}

	_getLine(pointer) {
		const points = [pointer.x, pointer.y, pointer.x, pointer.y];
		const line = new fabric.Line(points, {
			strokeWidth: 2,
			fill: '#999999',
			stroke: '#999999',
			class: 'line',
			originX: 'center',
			originY: 'center',
			selectable: false,
			hasBorders: false,
			hasControls: false,
			evented: false,
			objectCaching: false
		});
		return line;
	}

	_getPolygon(points) {
		const polygon = new fabric.Polygon(points, {
			stroke: '#333333',
			strokeWidth: 1,
			fill: '#cccccc',
			opacity: 0.3,
			selectable: false,
			hasBorders: false,
			hasControls: false,
			evented: false,
			objectCaching: false
		});
		return polygon;
	}

	_adjustPolygonStack() {
		this.pointArray.forEach((p) => this.canvas.bringToFront(p));
		this.canvas.bringToFront(this.activeShape);
	}

	_ajdustLastLine() {
		const firstPoint = this.pointArray[0];
		const lastLine = this.lineArray[this.lineArray.length - 1];
		lastLine.set({ x2: firstPoint.left, y2: firstPoint.top });
		lastLine.setCoords();
	}

	_removeExtraPointOnActiveShape() {
		const shapePoints = this.activeShape.get("points");
		if (shapePoints.length !== this.pointArray.length) {
			shapePoints.pop();
			this.activeShape.set({ points: shapePoints });
		}
	}

	_finishDrawing() {
		this.editorModeOn = true;
		this._ajdustLastLine();
		this._removeExtraPointOnActiveShape();
		this._editPolygon();
	}

	resetPolygon() {
		this.editorModeOn = false;

		if (typeof this._clearEditorPointsHandlers === 'function') {
			this._clearEditorPointsHandlers();
			this._clearEditorPointsHandlers = null;
		}

		if (this.pointArray && this.pointArray.length) {
			this.pointArray.forEach((point) => {
				this.canvas.remove(point);
			});
		}
		if (this.lineArray && this.lineArray.length) {
			this.lineArray.forEach((line) => {
				this.canvas.remove(line);
			});
		}
		if (this.activeShape) {
			this.canvas.remove(this.activeShape)
		}
		if (this.activeLine) {
			this.canvas.remove(this.activeLine);
		}
		this.activeLine = null;
		this.activeShape = null;
		this.pointArray = new Array();
		this.lineArray = new Array();
	}

	cancel() {
		if (this.editorModeOn === true && this.editingPolygon != null) {
			this.canvas.add(this.editingPolygon);
			this.canvas.renderAll();
			this.editingPolygon = null;
		}
		this.resetPolygon();
	}

	_addPoint(pointer) {
		const circle = this._getPoint(pointer);
		if (this.pointArray.length === 0) {
			circle.set({ fill: 'red' })
		}

		const line = this._getLine(pointer);
		this.activeLine = line;

		if (this.activeShape) {
			const shapePoints = this.activeShape.get("points");
			shapePoints[this.pointArray.length] = { x: pointer.x, y: pointer.y };
			this.activeShape.set({ points: shapePoints });
		} else {
			const polyPoint = [{ x: pointer.x, y: pointer.y }];
			const polygon = this._getPolygon(polyPoint);
			this.activeShape = polygon;
			this.canvas.add(polygon);
		}

		this.pointArray.push(circle);
		this.lineArray.push(line);

		this.canvas.add(line);
		this.canvas.add(circle);
		this.canvas.selection = false;
		this._adjustPolygonStack();
		this.canvas.renderAll();
	}

	_insertPoint(pointer, idx) {
		const circle = this._getPoint(pointer);
		const newLine = this._getLine(pointer);

		circle.selectable = true;
		this.canvas.setActiveObject(circle);

		const prevLine = this.lineArray[idx];
		prevLine.set({ x2: pointer.x, y2: pointer.y });
		if (idx === this.lineArray.length - 1) {
			const firstLine = this.lineArray[0];
			newLine.set({ x2: firstLine.x1, y2: firstLine.y1 });
		} else {
			const nextLine = this.lineArray[idx + 1];
			newLine.set({ x2: nextLine.x1, y2: nextLine.y1 });
		}
		prevLine.setCoords();
		newLine.setCoords();

		if (this.activeShape) {
			const shapePoints = this.activeShape.get("points");
			shapePoints.splice(idx + 1, 0, { x: pointer.x, y: pointer.y });
			this.activeShape.set({ points: shapePoints });
		}

		this.pointArray.splice(idx + 1, 0, circle);
		this.lineArray.splice(idx + 1, 0, newLine);

		this.canvas.add(newLine);
		this.canvas.add(circle);

		this._adjustPolygonStack();
		this.canvas.renderAll();
	}

	_movePoint(pointer, idx) {
		const shapePoints = this.activeShape.get("points");
		shapePoints[idx] = { x: pointer.x, y: pointer.y };
		this.activeShape.set({ points: shapePoints });

		const currLine = this.lineArray[idx];
		currLine.set({ x1: pointer.x, y1: pointer.y });
		if (idx === 0) {
			const lastLine = this.lineArray[this.lineArray.length - 1];
			lastLine.set({ x2: pointer.x, y2: pointer.y });
			lastLine.setCoords();
		} else {
			const prevLine = this.lineArray[idx - 1];
			prevLine.set({ x2: pointer.x, y2: pointer.y });
			prevLine.setCoords();
		}
		currLine.setCoords();

		this.canvas.renderAll();
	}

	_removePoint(idx) {
		this.canvas.remove(this.pointArray[idx]);
		this.canvas.remove(this.lineArray[idx]);

		if (idx === 0) {
			const currLine = this.lineArray[idx];
			const lastLine = this.lineArray[this.lineArray.length - 1];
			lastLine.set({ x2: currLine.x2, y2: currLine.y2 });
			lastLine.setCoords();
		} else {
			const currLine = this.lineArray[idx];
			const prevLine = this.lineArray[idx - 1];
			prevLine.set({ x2: currLine.x2, y2: currLine.y2 });
			prevLine.setCoords();
		}

		this.pointArray.splice(idx, 1);
		this.lineArray.splice(idx, 1);

		if (this.activeShape) {
			const shapePoints = this.activeShape.get("points");
			shapePoints.splice(idx, 1);
			this.activeShape.set({ points: shapePoints });
		}
		this.canvas.renderAll();
	}

	getPolygonPoints() {
		const points = this.pointArray.map((point) => ({
			x: point.left,
			y: point.top
		}));
		return points;
	}

	_editPolygon() {
		this.editorModeOn = true;

		this.pointArray[0].set({ fill: 'ffffff' });
		this.pointArray.forEach((p) => {
			p.selectable = true;
			p.hasBorders = true;
			p.on("moving", (e) => {
				const idx = this.pointArray.indexOf(p);
				if (idx > -1) {
					this._movePoint({ x: p.left, y: p.top }, idx);
				}
			});
			p.on("removed", (e) => {
				const idx = this.pointArray.indexOf(p);
				if (idx > -1) {
					this._removePoint(idx);
				}
			});
		});

		this.lineArray.forEach((l) => {
			l.evented = true;
			l.setCoords();
			l.on("mousedown", (e) => {
				const idx = this.lineArray.indexOf(l);
				if (idx > -1) {
					const pointer = this.canvas.getPointer(e.e);
					this._insertPoint(pointer, idx);
					this._clearEditorPointsHandlers();
					this._editPolygon();
				}
			});
		});

		this._clearEditorPointsHandlers = () => {
			this.pointArray.forEach((p) => {
				p.off('moving');
				p.off('removed');
			});
			this.lineArray.forEach((l) => {
				l.off('mousedown');
			});
		};

		this.canvas.renderAll();
	}

	loadShapeFromExistingPolygon(p) {
		this.editingPolygon = p;
		this.resetPolygon();

		this.canvas.remove(this.editingPolygon);

		const matrix = this.editingPolygon.calcTransformMatrix();
		const points = this.editingPolygon.get("points");
		points
			.map((p) => {
				const pClone = new fabric.Point(
					p.x - this.editingPolygon.pathOffset.x,
					p.y - this.editingPolygon.pathOffset.y);
				return fabric.util.transformPoint(pClone, matrix);
			})
			.map((pointer, idx) => {
				const circle = this._getPoint(pointer);
				const line = this._getLine(pointer);
				this.activeLine = line;

				if (idx > 0) {
					const prevLine = this.lineArray[idx - 1];
					prevLine.set({ x2: pointer.x, y2: pointer.y });
					prevLine.setCoords();
				}
				if (idx === points.length - 1) {
					const firstLine = this.lineArray[0];
					line.set({ x2: firstLine.x1, y2: firstLine.y1 });
				}

				if (this.activeShape) {
					const shapePoints = this.activeShape.get("points");
					shapePoints[this.pointArray.length] = { x: pointer.x, y: pointer.y };
					this.activeShape.set({ points: shapePoints });
				} else {
					const polyPoint = [{ x: pointer.x, y: pointer.y }];
					const polygon = this._getPolygon(polyPoint);
					this.activeShape = polygon;
					this.canvas.add(polygon);
				}

				this.pointArray.push(circle);
				this.lineArray.push(line);

				this.canvas.add(line);
				this.canvas.add(circle);
			});

		this.canvas.selection = false;
		this._adjustPolygonStack();
		this._editPolygon();
	}
}